import React, { useMemo } from 'react'
import { getHeroesByPublicher } from '../../selectors/getHeroesByPublicher'
import { HeroCard } from './HeroCard'

export const HeroesList = ({ publisher }) => {


    const heroes = useMemo(() => getHeroesByPublicher(publisher), [publisher])
    //const heroes = getHeroesByPublicher(publisher)

    return (
        <div className=' card-columns animate__animated animate__fadeIn'>

            {
                heroes.map(hero => (
                    <HeroCard
                        key={hero.id}
                        {...hero}
                    >
                    </HeroCard>
                ))
            }

        </div>

    )
}

//!el publisher es la compania

//! ... => estrae todos los argunmentos

